module.exports = __webpack_public_path__ + "img/icon6.ac7a7bf2.png";